import { render } from "./ImageChecker.vue?vue&type=template&id=196a64d2&scoped=true"
import script from "./ImageChecker.vue?vue&type=script&lang=js"
export * from "./ImageChecker.vue?vue&type=script&lang=js"

import "./ImageChecker.vue?vue&type=style&index=0&id=196a64d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a64d2"]])

export default __exports__